 const Footer = () =>{
return(
    <section className="bg-gradient-to-r from-indigo-800 via-purple-800 to-purple-900">
        <div className="flex justify-center p-8 text-xs md:text-sm text-white">
                <p>© 2022 |</p>
                <p> Developed By Osh_la</p>
        </div>

    </section>
)
 }
 export default Footer;